import http from '../../core/services/http'

export const generateScrapingClusterMenusReport = ({ scrapingClusterId }) =>
  http.get(`/reports/scraping-cluster-menus/${scrapingClusterId}`, {
    responseType: 'blob',
  })
